// extracted by mini-css-extract-plugin
export default {"contentOverlay":"Hero_contentOverlay__xeLwa","hero":"Hero_hero__zvVCj","video":"Hero_video__uxlw6","title":"Hero_title__rL9MQ","button":"Hero_button__r+LVG"};